import React, { FunctionComponent } from 'react'
import { Text, useDesignLanguagePerClass } from '@afterpaytouch/core'
import clsx from 'clsx'

import styles from './style.module.css'
import { useCheckoutSizes } from '../../utils/responsive'
import { getPaddingStyle } from './utils'
import { Padding } from './types'

// Unstable component - Specification is not finalised.
// Potential design system candidate

export interface ModuleContainerProps extends React.AnchorHTMLAttributes<HTMLDivElement> {
  mintBorder?: boolean
  nested?: boolean
  padding?: Padding
  errorText?: string | string[] | JSX.Element
  showErrorBorder?: boolean
  containerRef?: React.RefObject<HTMLDivElement>
  testNameSpace?: string
  disabled?: boolean
  noBottomMargin?: boolean
  extraBottomMargin?: boolean
  extraTopMargin?: boolean
  reducedHeight?: boolean
  showBorder?: boolean
  withoutContainer?: boolean
}

export const ModuleContainer: FunctionComponent<ModuleContainerProps> = ({
  children,
  mintBorder,
  nested,
  padding,
  errorText = [],
  showErrorBorder = false,
  className,
  containerRef,
  testNameSpace = '',
  disabled = false,
  extraBottomMargin = false,
  noBottomMargin = false,
  reducedHeight = false,
  extraTopMargin = false,
  showBorder = true,
  withoutContainer = false,
  ...otherProps
}) => {
  const { smallTextSize } = useCheckoutSizes()
  const isNested = typeof nested === 'boolean' && nested
  const errorTextArray = Array.isArray(errorText) ? errorText : [errorText]
  const hasError = typeof errorTextArray[0] !== 'undefined' && errorTextArray[0] !== null
  const designLanguageClass = useDesignLanguagePerClass(styles)

  const classNames = clsx(
    className,
    disabled && styles.disabledState,
    !isNested && styles.moduleContainer,

    !isNested && showBorder && (mintBorder === true ? styles.mintBorder : styles.regularBorder),
    noBottomMargin && styles.noBottomMargin,
    extraBottomMargin && designLanguageClass.extraBottomMargin,
    getPaddingStyle(padding),
    hasError && showBorder && showErrorBorder && styles.errorBorder,
    reducedHeight && styles.reducedHeight,
    extraTopMargin && designLanguageClass.extraTopMargin
  )

  const renderErrors = (): JSX.Element[] | false => {
    return (
      hasError &&
      errorTextArray
        ?.filter((text) => text !== '')
        .map((error, i) => (
          <div className={styles.errorText} key={i}>
            <Text size={smallTextSize}>{error}</Text>
          </div>
        ))
    )
  }
  if (withoutContainer) {
    return <>{children}</>
  }

  return (
    <>
      <div ref={containerRef} className={classNames} {...otherProps} {...(testNameSpace.length > 0 && { 'data-testid': testNameSpace })}>
        {children}
      </div>
      {renderErrors()}
    </>
  )
}
